import type { NotFoundUiContent } from '../../not-found-ui-content';

export const notFound: NotFoundUiContent = {
  eyebrow: 'Tudalen heb ei chanfod',
  title: "Ni lwyddom i ddod o hyd i'r dudalen honno",
  body: "Efallai fod y ddolen wedi dyddio, neu fod y dudalen wedi'i dileu. Dywedwch wrthym beth rydych yn chwilio amdano a byddwn yn dod o hyd iddo.",
  suggestionsTitle: 'Efallai eich bod yn chwilio am',
  bestMatchTitle: "Oeddech chi'n golygu",
  prefillHint: "Wedi'i lenwi ymlaen llaw o'r cyfeiriad y ceisioch ei agor",
  goHome: 'Hafan',
  browseAll: 'Pob categori',
  reportBrokenLink: 'Rhoi gwybod am ddolen sydd wedi torri',
  noticeTitle: "Nid yw'r dudalen honno ar gael",
  noticeSearching: 'Yn chwilio am {query} yn lle hynny…',
  noticePrefilled: "Chwiliwch am {query} isod, neu dywedwch wrthym beth sydd ei angen arnoch.",
  errorTitle: "Aeth rhywbeth o'i le",
  errorBody: "Ni lwyddom i lwytho'r dudalen hon. Ceisiwch eto, neu chwiliwch am yr hyn sydd ei angen arnoch isod.",
  retry: 'Ceisiwch eto',
  streamLostTitle: "Ni lwyddom i orffen y dudalen hon",
  streamLostBody: "Daeth y chwiliad i ben cyn i'r dudalen gael ei chadw. Dechreuwch y chwiliad eto a byddwn yn ailgychwyn o'ch geiriau chi.",
  relaunch: 'Chwilio eto',
};
